export default {
  getCompanyClient: state => state.items
}



// WEBPACK FOOTER //
// ./src/store/modules/company_clients/getters.js